import { createPermission } from '@backstage/plugin-permission-common';

export const chartSummaryReadPermission = createPermission({
  name: 'chart-summary.read',
  attributes: { action: 'read' }
});
